import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/ava/")({
  component: AvaWelcome,
});

function AvaWelcome() {
  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-br from-blue-50 to-purple-50">
      <div className="max-w-md text-center">
        <div className="mb-6">
          <div className="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-r from-blue-500 to-purple-600 shadow-lg">
            <svg
              className="h-10 w-10 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
              />
            </svg>
          </div>
          <h1 className="mb-3 text-3xl font-bold text-gray-900">
            Welcome to AVA
          </h1>
          <p className="mb-6 text-lg text-gray-600">
            Your AI mentor assistant powered by advanced language models
          </p>
        </div>

        <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <h3 className="mb-4 text-lg font-semibold text-gray-800">
            Get Started
          </h3>
          <div className="space-y-4 text-sm text-gray-600">
            <div className="flex items-center gap-4 text-left">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-600">
                1
              </div>
              <span>Select an existing chat from the sidebar</span>
            </div>
            <div className="flex items-center gap-4 text-left">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-600">
                2
              </div>
              <span>Or create a new conversation to begin</span>
            </div>
            <div className="flex items-center gap-4 text-left">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-600">
                3
              </div>
              <span>Ask AVA about mentoring, youth development, and more</span>
            </div>
          </div>
        </div>

        <p className="mt-6 text-sm text-gray-500">
          AVA can help with mentoring strategies, youth development insights,
          and administrative guidance
        </p>
      </div>
    </div>
  );
}
